export const getDefaultHeaders = (userData: any) => {
  let headers = {};
  if (!userData) {
    return headers;
  }

  try {
    const {
      tenantId = '',
      userId = '',
      customerId = '',
      username = '',
    } = userData;
    headers = {
      'x-app-id': 'customer_portal',
      'x-tenant-id': tenantId,
      'x-user-id': userId,
      'x-user-name': username,
      'x-customer-id': customerId,
    };
  } catch (error) {
    // TODO
  }

  return headers;
};

export default getDefaultHeaders;
